import api from '@/api';
import { QuestAccountsPayableRequest } from './AccountsPayable.types';
import { API_BASE_URL } from '../../index';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportAccountsPayable(
  params: QuestAccountsPayableRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/AccountsPayable`,
    params,
  )) as unknown;

  return result as BlobPart;
}
